export const ERROR__SPEAKER__IMAGE_ALREADY_ADDED = "speaker.imageAlreadyAdded"
export const ERROR_SCHEDULE_ITEM__DATE_END_LESS_THAN_START = "scheduleItem.dateEndLessThanStart"

export const ERROR_REASON_CODE_NOT_CHANGED = { code: "auth.codeNotChanged" }
export const ERROR_REASON_DOMAIN_NOT_CHANGED = { code: "auth.domainNotChanged" }
export const ERROR_REASON_METRIKA_ID_NOT_CHANGED = { code: "auth.metrikaIdNotChanged" }
export const ERROR_REASON_DOMAIN_INVALID = { code: "auth.domainInvalid" }
export const ERROR_REASON_PASSWORDS_NOT_MATCH = { code: "auth.passwordsNotMatch" }
export const ERROR_REASON_PASSWORD_THE_SAME_WITH_CURRENT = { code: "auth.newPasswordTheSameWithOld" }
export const ERROR_REASON_RESET_PASSWORD_CODE_NOT_FOUND = { code: "auth.resetPasswordCodeNotFound" }

export const ERROR_TIMEZONE_NOT_VALID = { code: "timeZone.notValid" }
